import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLocation, LocationDistance } from '@grandvisionhq/locations';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { formatDistanceQueryData } from '../../pages/details/adapters.js';
import useStoreDistance from '../../pages/details/hooks/use-store-distance.js';

function StoreDistanceContainer({ className , code  }) {
    const { distanceUnit , locale  } = useIntl();
    const [hasPermissions, setHasPermissions] = React.useState(false);
    const { featureConfigs: { storeDistanceConfig  } = {}  } = useFeatureToggles();
    const { position: deviceLocation , setIsMyLocationRequested  } = useLocation(false, {
        enableHighAccuracy: true,
        maximumAge: 1000
    });
    const [getStoreDistance, { data  }] = useStoreDistance();
    const distanceProps = React.useMemo(()=>data ? formatDistanceQueryData(data, {
            distanceUnit,
            locale
        }) : {}
    , [
        data,
        distanceUnit,
        locale
    ]);
    React.useEffect(()=>{
        if (deviceLocation) {
            getStoreDistance({
                variables: {
                    code,
                    deviceGeoLocation: {
                        lat: deviceLocation.lat,
                        lon: deviceLocation.lng
                    },
                    withDistance: storeDistanceConfig === null || storeDistanceConfig === void 0 ? void 0 : storeDistanceConfig.distance,
                    withTimeByCar: storeDistanceConfig === null || storeDistanceConfig === void 0 ? void 0 : storeDistanceConfig.timeByCar,
                    withTimeByFoot: storeDistanceConfig === null || storeDistanceConfig === void 0 ? void 0 : storeDistanceConfig.timeByFoot
                }
            });
        }
    }, [
        code,
        deviceLocation,
        storeDistanceConfig,
        getStoreDistance
    ]);
    React.useEffect(()=>{
        if (hasPermissions) {
            setIsMyLocationRequested(true);
        } else {
            setIsMyLocationRequested(false);
        }
    }, [
        hasPermissions,
        setIsMyLocationRequested
    ]);
    React.useEffect(()=>{
        let unsubscribe;
        if ('permissions' in navigator) {
            navigator.permissions.query({
                name: 'geolocation'
            }).then((permissionStatus)=>{
                setHasPermissions(permissionStatus.state === 'granted');
                const handler = ()=>{
                    setHasPermissions(permissionStatus.state === 'granted');
                };
                permissionStatus.addEventListener('change', handler);
                unsubscribe = ()=>permissionStatus.removeEventListener('change', handler)
                ;
            });
        }
        return unsubscribe;
    }, []);
    return /*#__PURE__*/ React.createElement(LocationDistance, swcHelpers.extends({
        className: className
    }, distanceProps));
}
var StoreDistance = /*#__PURE__*/ React.memo(StoreDistanceContainer);

export { StoreDistance as default };
//# sourceMappingURL=StoreDistanceContainer.js.map
